// Paleta e helpers da tela de assinatura (redesenho 2026-06).
//
// Regra do redesenho: UMA cor de marca (laranja) pra ação/destaque; cinza pra
// estrutura; e verde/vermelho/âmbar SÓ com significado (sucesso/erro/aviso).
// Antes a tela misturava amarelo, azul, verde e 4 tons de laranja sem lógica.
export const CORES = {
	// marca (laranja) — ação primária, destaque, ícones de seção
	marca: "#ff7a18",
	marcaEscura: "#c2410c", // texto/realce sobre fundo claro
	marcaBg: "#fff7f0", // tint de fundo suave
	marcaBorda: "#ffd8bf",

	// neutros — estrutura
	tinta: "rgba(0,0,0,0.85)",
	tinta2: "rgba(0,0,0,0.55)",
	tinta3: "rgba(0,0,0,0.40)",
	borda: "#eef0f2",
	linha: "#f0f0f0",
	fundoSuave: "#fafbfc",

	// semânticos — só com significado
	sucesso: "#389e0d",
	sucessoBg: "#f6ffed",
	sucessoBorda: "#b7eb8f",
	perigo: "#cf1322",
	perigoBg: "#fff1f0",
	perigoBorda: "#ffccc7",
	aviso: "#d48806",
	avisoBg: "#fffbe6",
	avisoBorda: "#ffe58f",
	info: "#0958d9",
	infoBg: "#e6f4ff",
	infoBorda: "#91caff",
};

// Formatação única de moeda BRL — antes cada componente reimplementava
// `.toFixed(2).replace(".", ",")` com pequenas divergências.
export const fmtBRL = (v) =>
	`R$ ${Number(v || 0)
		.toFixed(2)
		.replace(".", ",")}`;

// Plural enxuto: pluralizar("aluno", 1) => "aluno"; (…, 5) => "alunos".
// Mata os "aluno(s)" preguiçosos espalhados pela tela.
export const pluralizar = (palavra, n, pluralExplicito) =>
	Number(n) === 1 ? palavra : pluralExplicito || `${palavra}s`;
